import React from 'react';
import './Title.css';

const Title = ({title}) => {
    return (
        <div className="title">
            {title}
        </div>
    )
};

export default Title;


// WEBPACK FOOTER //
// ./src/components/detail/title/Title.js